"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CHECKBOX_CONTENT = exports.CHECKBOX = exports.CHECKBOX_CONTAINER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    cyan = _vars.COLOURS.cyan,
    grey = _vars.COLOURS.grey,
    mono = _vars.COLOURS.mono,
    CHECKBOX_CONTAINER = function CHECKBOX_CONTAINER(a) {
  var b = a.disabled;
  return (0, _cxs["default"])({
    alignItems: "center",
    cursor: b ? "auto" : "pointer",
    display: "flex"
  });
};

exports.CHECKBOX_CONTAINER = CHECKBOX_CONTAINER;

var CHECKBOX = function CHECKBOX(a) {
  return (0, _cxs["default"])({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: a ? cyan.jungleGreen.monkey : mono.offwhite15,
    border: "1px solid ".concat(a ? cyan.jungleGreen.monkey : grey.mischka.russian),
    borderRadius: "4px",
    boxSizing: "border-box",
    width: "25px",
    minWidth: "25px",
    height: "25px",
    minHeight: "25px",
    opacity: a ? "1" : "0.5",
    " .check-box__box__check-icon": {
      marginRight: "2px",
      marginTop: "1px"
    }
  });
};

exports.CHECKBOX = CHECKBOX;
var CHECKBOX_CONTENT = (0, _cxs["default"])({
  fontSize: _vars.FONT_SIZES.small,
  marginLeft: "10px"
});
exports.CHECKBOX_CONTENT = CHECKBOX_CONTENT;